export default __webpack_public_path__ + "static/media/default.ff1547827bb8d6110946a8c5ce2fd5f5.svg";